import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MDBContainer,
} from "mdb-react-ui-kit";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { handleNavLinks } from "Projects/CC_cubi_clan_project/Utils/Utils";
import { getApp, getAppPermisions } from "Projects/CC_cubi_clan_project/Utils/PermissionManager";
import { MisCuentas } from "../../Components/MisCuentas/MisCuentas";
import { DetalleCuenta } from "../../Components/DetalleCuenta/DetalleCuenta";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import CCONMainComponent from "../../Components/CCONMainComponent/CCONMainComponent";

export default function CCONHomeView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [navActive, setNavActive] = useState("Home");
  const [isLoading, setLoading] = useState(false);
  const [appPermissions, setAppPermissions] = useState([]);
  const [navMenu, setNavMenu] = useState();
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(["miCookie"]);

  const navMenuDefault = [
    {
      devName: "AccountList",
      label: "Mis Cuentas",
      url: "/ccon/miscuentas",
      disabled: false,
      permissionRequired: ["APP_ACCESS"]
    },
    {
      devName: "Home",
      label: "Home",
      url: "/ccon",
      disabled: false,
      permissionRequired: ["APP_ACCESS"],
      active: true
    },
    {
      devName: "AppList",
      label: "Aplicaciones",
      disabled: false,
      permissionRequired: [],
    },
  ];

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData(event) {
    let app = await getApp("CCON", setLoading);
    let appPermissions = await getAppPermisions(app, setLoading);
    setAppPermissions(appPermissions);
    setNavMenuVisibles(appPermissions);
  }

  function setNavMenuVisibles(appPermissions) {
    for (let nav of navMenuDefault) {
      nav.visible = true;
      for (let per of nav.permissionRequired) {
        if (!appPermissions?.find((element) => element.nombre === per)) {
          nav.visible = false;
          break;
        }
      }
    }
    setNavMenu(navMenuDefault);
  }

  const onHandleNavLinks = (event, url) => {
    handleNavLinks(event, url, navigate, setNavActive);
  };

  return (
    <div>
      <LoadingSpinner isLoading={isLoading}/>
      {navMenu ? (
        <NavMenu
          title="Single Sign On"
          appCode="CCON"
          navMenu={navMenu}
          isLoggedIn={true}
          onHandleNavLinks={onHandleNavLinks}
          onLoading={setLoading}
          onNavigate={navigate}
        ></NavMenu>
      ) : (
        <></>
      )}
      <MDBContainer>
        {location.pathname === "/ccon" ? (
          <CCONMainComponent></CCONMainComponent>
        ) : (
          <></>
        )}
        {location.pathname === "/ccon/miscuentas" ? (
          <MisCuentas
            onNavigate={(event) => navigate(event)}
            onLoading={setLoading}
            onHandleNavLinks={(event, url) => handleNavLinks(event, url, navigate, setNavActive)}
          />
        ) : (
          <></>
        )}
        {location.pathname.includes("/ccon/cuenta/") ? (
          <DetalleCuenta
            onNavigate={(event) => navigate(event)}
            onLoading={setLoading}
          />
        ) : (
          <></>
        )}
          {location.pathname.includes("/ccon/grupo/") ? (
            <DetalleCuenta
              onNavigate={(event) => navigate(event)}
              onLoading={setLoading}
            />
          ) : (
            <></>
          )}
      </MDBContainer>
    </div>
  );
}
